// Microsoft's sign-in button: a quiet full-width secondary action with the Microsoft mark on the left.

import * as React from "react";
import { cn } from "../../utils/helper";
import microsoft from "../../assets/images/microsoft.png";

export interface MicrosoftButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {}

const microsoftButtonStyle =
  "inline-flex h-12 w-full items-center justify-center gap-3 rounded-lg border border-inputBorder bg-white text-base font-semibold text-primaryText transition-colors duration-150 hover:bg-background focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary disabled:opacity-60 motion-reduce:transition-none";

const MicrosoftButton = React.forwardRef<HTMLButtonElement, MicrosoftButtonProps>(
  ({ className, children, ...props }, ref) => {
    return (
      <button
        type="button"
        className={cn(microsoftButtonStyle, className)}
        ref={ref}
        {...props}
      >
        <img src={microsoft} alt="" className="h-5 w-5" />
        {children}
      </button>
    );
  }
);

MicrosoftButton.displayName = "MicrosoftButton";

export { MicrosoftButton, microsoftButtonStyle };
